// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs .tab{cursor:pointer;border-bottom-width:2px;border-color:transparent;font-family:Roboto Slab, Georgia, serif;font-size:0.75rem;font-weight:700;text-transform:uppercase}@media (min-width: 768px){.tabs .tab{font-size:1rem}}.tabs .tab-selected{--tw-border-opacity:1;border-color:rgb(34 197 94 / var(--tw-border-opacity));font-weight:700;--tw-text-opacity:1;color:rgb(34 197 94 / var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
